import ISO_COUNTRIES_EN from 'i18n-iso-countries/langs/en.json';
import ISO_COUNTRIES_FR from 'i18n-iso-countries/langs/fr.json';
import { fromJS } from 'immutable';
import { remove, toPairs } from 'lodash';

import { SUPPORTED_LANGUAGES } from 'constants/languages.constants';

const enCountries = toPairs(ISO_COUNTRIES_EN.countries).map(([code, name]) => ({
  name,
  code,
}));

const frCountries = toPairs(ISO_COUNTRIES_FR.countries).map(([code, name]) => ({
  name,
  code,
}));

function prioritizeCountries(countryList) {
  const prioritizedCountries = [...countryList];

  const [canada] = remove(prioritizedCountries, ['code', 'CA']);

  const [usa] = remove(prioritizedCountries, ['code', 'US']);

  prioritizedCountries.splice(0, 0, usa);
  prioritizedCountries.splice(0, 0, canada);

  return prioritizedCountries;
}

function formatCountriesForDropdown(countryList) {
  return fromJS(
    countryList.map((country) => ({
      id: country.code,
      renderedValue: country.name,
      value: country.code,
    }))
  );
}

function formatCountriesForSelect(countryList) {
  return countryList.map((country) => ({
    value: country.code,
    key: country.code,
    label: country.name,
  }));
}

const enPrioritizedCountries = prioritizeCountries(enCountries);
const frPrioritizedCountries = prioritizeCountries(frCountries);

/* eslint-disable import/prefer-default-export */
export const PRIORITIZED_COUNTRIES = {
  EN: {
    RAW: enPrioritizedCountries,
    FOR_DROPDOWN: formatCountriesForDropdown(enPrioritizedCountries),
    FOR_SELECT: formatCountriesForSelect(enPrioritizedCountries),
  },
  FR: {
    RAW: frPrioritizedCountries,
    FOR_DROPDOWN: formatCountriesForDropdown(frPrioritizedCountries),
    FOR_SELECT: formatCountriesForSelect(frPrioritizedCountries),
  },
};
